package com.wintermar.inspection.feature.presentation.inspection.answer.widget.choice_answer

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.SelectableItem
import com.wintermar.inspection.feature.domain.model.template.InspectionTemplateQuestionModel

@Composable
actual fun ChoiceAnswer(
    question: InspectionTemplateQuestionModel,
    onClick: (String) -> Unit
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(LocalAppTheme.current.dimension.spacing.space2),
        verticalAlignment = Alignment.CenterVertically
    ) {
        question.answerOptions.forEach { option ->
            val color = question.answerType.contentColor(option.order)
            Column(modifier = Modifier.weight(1f)) {
                SelectableItem(
                    selected = question.answer.answerOptionId == option.id,
                    text = option.label,
                    backgroundColor = color.backgroundColor,
                    borderColor = color.borderColor,
                    textColor = color.textColor,
                    badgeColor = color.badgeColor,
                    onClick = {
                        onClick(option.id)
                    }
                )
            }
        }
    }
}
